import { isNullOrUndefined, findRule } from '../Utils';

const validate = (vObj) => {
  const { value } = vObj;
  const rule = findRule(vObj.errorBag, 'min');
  const length = rule.ruleParams;

  rule.feedback = `${
    vObj.fieldlabel
  } requires a minimum of ${length} characters`;

  if (isNullOrUndefined(value)) {
    return false;
  }

  return String(value).length >= length;
};

export { validate };

export default {
  validate,
};
